import { Utils } from "../../common/views/Utils"

export enum CollageDisplayCount {
    one = 1,
    two = 2,
    three = 3,
    four = 4,
    five = 5
}

export enum CollageLayout {
    horizontalHalf = 1,
    horizontalTwoThird = 2,
    verticalHalf = 3,
    verticalTwoThird = 4,
    allSquare = 5
}

export enum PhotoSize {
    oneThird = 0,
    half = 1,
    twoThird = 2,
    full = 3,
    extraFull = 4
}

export class PhotoDimension {
    public width: number
    public height: number

    constructor(width: number, height?: number) {
        this.width = width

        if (height) {
            this.height = height
        } else {
            this.height = width
        }
    }

    public getExtraWidth(): number {
        return this.width * 1.15
    }

    public getSpacing(): number {
        return this.width * 0.01
    }

    public getHalf(): number {
        return (this.width - this.getSpacing()) / 2.0;
    }

    public getOneThird(spaceCount: number = 2): number {
        return (this.width - this.getSpacing() * spaceCount) / 3.0;
    }

    public getTwoThird(): number {
        return (this.width - this.getSpacing()) * 2.0 / 3.0;
    }
}

export class PhotoCollageStyle {
    public space: number
    public tall: boolean
    public outerFloat: any
    public innerFloat: any
    public paddingRight: number
    public paddingBottom: number
    public innerDisplay: string

    constructor(space: number, tall: boolean) {
        this.space = space;
        this.tall = tall;

        if (tall) {
            this.outerFloat = "left";
            this.innerFloat = "right";
            this.paddingRight = 0;
            this.paddingBottom = space;
            this.innerDisplay = "flex";
        } else {
            this.outerFloat = "unset";
            this.innerFloat = "left";
            this.paddingRight = space;
            this.paddingBottom = 0;
            this.innerDisplay = "inline-block";
        }
    }
}

export class CollageLayoutManager {
    public layout: CollageLayout

    constructor(layout: CollageLayout) {
        this.layout = layout;
    }

    public getName(): string {
        return Utils.splitCapitalCase(CollageLayout[this.layout]);
    }

    public isTall(): boolean {
        return this.layout === CollageLayout.horizontalHalf ||
            this.layout === CollageLayout.horizontalTwoThird;
    }

    public isHalf(): boolean {
        return this.layout === CollageLayout.horizontalHalf ||
            this.layout === CollageLayout.verticalHalf ||
            this.layout === CollageLayout.allSquare;
    }
}

export class PhotoCollageTemplateModel {
    public id: number = 0;
    public displayCount: CollageDisplayCount = CollageDisplayCount.one;
    public layout: CollageLayout = CollageLayout.allSquare;
}